import {__} from "./__";

export const getAiAddonNames = () => {
    return {
        related_products: __('AI podobné produkty'),
        search: __('AI vyhľadávanie'),
        chat: __('AI chatbot'),
        mailer: __('AI mailer'),
    };
};
